import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { Modal, ModalBody } from "reactstrap"

const OnboardInfo = ({ kycData }) => {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (kycData?.completed_steps && kycData?.completed_steps.length <= 0) {
      setOpen(true)
    }
  }, [kycData])

  return (
    <>
      <Modal
        size="md"
        isOpen={open}
        toggle={() => setOpen(false)}
        backdrop="static"
        centered={true}
      >
        <ModalBody className="px-4 pt-5 pb-4">
          <button
            type="button"
            onClick={() => setOpen(false)}
            className="btn-close position-absolute end-0 top-0 m-3"
          ></button>
          <h5
            className="title mb-1 text-center"
            style={{
              color: "#035c98",
              fontSize: "18px",
            }}
          >
            Please keep the following documents handy
          </h5>
          <p className="text-center">
            Every investor is requested to keep the following documents readily
            available to complete the KYC process.
          </p>
          <div
            style={{
              background: "#f5f5f5",
              padding: "10px",
              borderRadius: "20px",
              fontSize: "14px",
              marginBottom: "20px",
            }}
          >
            <ol
              style={{
                margin: "10px",
              }}
            >
              <li>PAN Card of Company</li>
              <li>Memorandum of Association (MOA) of Company</li>
              <li>Articles of Association (AOA) of Company</li>
              <li>Certificate of Incorporation (COI) of Company</li>
              <li>GST Certificate, if applicable</li>
              <li>Cancelled Cheque of Company</li>
              <li>Aadhaar Card of Authorised Person</li>
              <li>Authority Letter of Company</li>
            </ol>
          </div>

          <span
            className="text-muted"
            style={{
              fontStyle: "italic",
            }}
          >
            Note: PAN Card & Cancelled Cheque - File format: .jpeg, .png <br />
            Other remaining documents - File format: .pdf
          </span>
          <div className="hstack gap-2 justify-content-center mb-0 mt-2">
            <button
              type="button"
              className="btn btn-primary w-100"
              onClick={() => setOpen(false)}
            >
              Start KYC
            </button>
          </div>
        </ModalBody>
      </Modal>
    </>
  )
}

export default OnboardInfo
